import { Field } from '@headlessui/react';
import { FC, useState } from 'react';
import { Label } from '@/components/form/label';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Drawer } from '@/components/ui/drawer';
import { SectionHeadingGroup } from '@/components/ui/section-heading-group';
import { useForm } from '@/forms/hooks/use-form';
import { FormSchema } from '@/forms/types/schema';
import { useCurrentUnit } from '@/hooks/use-current-unit';
import { DrawerContentFormLayout } from '@/layouts/drawer-content-form-layout';
import { SectionContainerLayout } from '@/layouts/section-container-layout';

// Interface type for the form elements
interface NotificationFormValues {
  email: string;
}

export const NotificationsView: FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { data: unit, updateUnit } = useCurrentUnit();

  // Schema for the form
  const formSchema: FormSchema<NotificationFormValues> = {
    email: {
      type: 'text',
      label: 'Email',
      placeholder: 'Enter an email (optional)',
      value: unit?.email,
      validation: {
        required: false,
      },
    },
  };

  // Use the custom useForm hook to handle form state
  const { fieldItems, handleSubmit } = useForm<NotificationFormValues>({
    schema: formSchema,
    onSubmit: async (values) => {
      updateUnit(values.email);
      setIsOpen(false);
    },
  });

  return (
    <>
      <SectionContainerLayout horizontal className="border-b-0">
        <SectionHeadingGroup
          className="mb-6"
          subtitle="Overide the default organisation notification settings for this unit."
          title="Notifications"
        />

        <div className="w-min min-w-60 grow">
          <Card>
            <Field>
              <Label>Email</Label>

              <div className="mt-2 flex items-center gap-2">
                {unit?.email ? <div>{unit.email}</div> : null}

                <Button
                  className="text-xs"
                  onClick={() => setIsOpen(true)}
                  variant="secondary"
                >
                  {unit?.email?.length ? 'Edit' : 'Add email override'}
                </Button>
              </div>
            </Field>
          </Card>
          <Drawer open={isOpen} setOpen={setIsOpen} title="Edit Email address">
            <DrawerContentFormLayout
              buttonItems={[
                <Button
                  key="cancel"
                  onClick={() => setIsOpen(false)}
                  variant="secondary"
                >
                  Cancel
                </Button>,
                <Button key="save" type="submit">
                  Save
                </Button>,
              ]}
              fieldItems={fieldItems}
              onSubmit={handleSubmit}
            />
          </Drawer>
        </div>
      </SectionContainerLayout>
    </>
  );
};
